// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/ai';
import { ɵzoneWrap } from '@angular/fire';
import {
  getAI as _getAI,
  getGenerativeModel as _getGenerativeModel,
  getImagenModel as _getImagenModel,
  getVertexAI as _getVertexAI
} from 'firebase/ai';

export const getAI = ɵzoneWrap(_getAI, true);
export const getGenerativeModel = ɵzoneWrap(_getGenerativeModel, true);
export const getImagenModel = ɵzoneWrap(_getImagenModel, true);
export const getVertexAI = ɵzoneWrap(_getVertexAI, true);
